import { useSelector } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ExpandableListItemProps, IconName } from '@optimus-web/core';
import { hasCurrentEnterpriseServiceProviderMode } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import {
    isCurrentProfilePlatformAdmin,
    canCurrentProfileConfigureEnterprise,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';

export const PortfolioQueueMenu = (
    props: Partial<ExpandableListItemProps> & {
        value: string;
    }
) => {
    const isPlatformAdmin = useSelector(isCurrentProfilePlatformAdmin);
    const hasServiceProviderMode = useSelector(hasCurrentEnterpriseServiceProviderMode);
    const canConfigureEnterprise = useSelector(canCurrentProfileConfigureEnterprise);

    if (!isPlatformAdmin && !hasServiceProviderMode && !canConfigureEnterprise) {
        return null;
    }
    return (
        <SidebarExpandableListItem
            leftIcon={<SidebarFontIcon value={IconName.Queues} />}
            {...props}
            primaryText={<LocalizedText textKey={TextKey.QueuePlural} />}
        >
            {createListItemWithLink({
                textKey: TextKey.ImportPlural,
                iconName: IconName.SettingsUser,
                path: 'ImportQueueItem/Index',
            })}
            {createListItemWithLink({
                textKey: TextKey.RatesAndVouchers,
                iconName: IconName.SettingsUser,
                path: 'FileProcessingQueueItem/Index',
            })}
        </SidebarExpandableListItem>
    );
};
